import { createAsyncThunk } from '@reduxjs/toolkit';

import { ThunkApiConfigType } from '../../../../main/store/main.store.ts';

import { AUTH_SLICE_NAME } from '../auth.slice.types.ts';

export const postSignUpThunk = createAsyncThunk<void, void, ThunkApiConfigType>(
  `${AUTH_SLICE_NAME}/postSignUp`,
  (_, _thunkAPI) => {
    //
  }
);
